export default class QueryRelationJoinMode
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryRelationJoinMode";

	static None = "None";
	static InnerJoin = "InnerJoin";
	static LeftJoin = "LeftJoin";
	static ExistJoin = "ExistJoin";
	static NotExistJoin = "NotExistJoin";
		
	static labelOf(value)
	{
		switch(value)
		{
			case QueryRelationJoinMode.None:
				return "None";
			case QueryRelationJoinMode.InnerJoin:
				return "InnerJoin";
			case QueryRelationJoinMode.LeftJoin:
				return "LeftJoin";
			case QueryRelationJoinMode.ExistJoin:
				return "ExistJoin";
			case QueryRelationJoinMode.NotExistJoin:
				return "NotExistJoin";
			default :
				throw new Error("类型非法");
		}
	}
		
	static valueOf(value)
	{
		switch(value)
		{
			case "None":
			case "":
				return QueryRelationJoinMode.None;
			case "InnerJoin":
				return QueryRelationJoinMode.InnerJoin;
			case "LeftJoin":
				return QueryRelationJoinMode.LeftJoin;
			case "ExistJoin":
				return QueryRelationJoinMode.ExistJoin;
			case "NotExistJoin":
				return QueryRelationJoinMode.NotExistJoin;
			default :
				throw new Error("类型非法");
		}
	}
		
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryRelationJoinMode.js